import {combineReducers} from 'redux'
import engage from './engage-reducer'

const rootReducer = combineReducers({
  engage
});


export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js